export default __webpack_public_path__ + "media/images/onglet-droite-6c0a82c781814f68eedf5d3d22afa8a7.png";